import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum OperatorsFormErrorStatesEnum {
    CreateOperatorFailed = ErrorStateScheduleEnum.OperatorsFormStatesStartIndex,
    AssignRoleToUserFailed,
    GetUserFailed,
    UserExists,
    UserConfirmationEmailSendFailed,
    UpdateOperatorFailed,
    UpdateOperatorStatusFailed
}
